import { gql } from '@apollo/client';

export const GET_DAILY_BEST_BETS = gql`
  query GetDailyBestBets($date: String!, $analysisTypeId: Int = 1) {
    dailyBestBets(date: $date, analysisTypeId: $analysisTypeId) {
      bestBets {
        raceId
        raceNumber
        horseName
        trackName
        trackCode
        state
        meetingId
        confidence
        marketOdds
        assessedOdds
        adjustedAssessedProb
        valuePercentage
        raceTime
        betType
        analysis
        pros
        cons
        tabNumber
        meetingDate
        finishPosition
        resultStatus
        isConsensusPick
      }
      valueBets {
        raceId
        raceNumber
        horseName
        trackName
        trackCode
        state
        meetingId
        confidence
        marketOdds
        assessedOdds
        adjustedAssessedProb
        valuePercentage
        raceTime
        betType
        analysis
        pros
        cons
        tabNumber
        meetingDate
        finishPosition
        resultStatus
        isConsensusPick
      }
      totalBets
      date
    }
  }
`;
